import React, { useEffect, useRef } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const ChatMessages = ({ messages, loading }) => {
    const visibleMessages = messages.filter(msg => msg.role !== 'internal');
    const bottomRef = useRef(null);

    useEffect(() => {
        if (bottomRef.current) {
            const prefersReducedMotion =
                typeof window !== 'undefined' &&
                typeof window.matchMedia === 'function' &&
                window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            bottomRef.current.scrollIntoView({
                behavior: prefersReducedMotion ? 'auto' : 'smooth'
            });        }
    }, [visibleMessages, loading]);

    return (
        <div className="roxy-panel__body">
            {visibleMessages.map((msg, idx) => (
                <div key={idx} className={`roxy-panel__message-wrapper roxy-panel__message-wrapper--${msg.role}`}>
                    <div className={`roxy-panel__message roxy-panel__message--${msg.role}`}>
                        <ReactMarkdown  remarkPlugins={[remarkGfm]}  components={{
                            a: ({ node: _node, href, ...props }) => (
                                <a {...props} href={href} target="_blank" rel="noopener noreferrer" />
                            ),
                            p: ({ node, ...props }) => <p {...props} style={{ margin: 0 }} />,
                            ul: ({ node, ...props }) => <ul {...props} style={{ margin: 0, paddingLeft: '1.25rem' }} />,
                            ol: ({ node, ...props }) => <ol {...props} style={{ margin: 0, paddingLeft: '1.25rem' }} />,
                            li: ({ node, ...props }) => <li {...props} style={{ margin: 0 }} />
                        }}>
                            {msg.content}
                        </ReactMarkdown>
                    </div>
                </div>
            ))}
            {loading && (
                <div className="roxy-panel__message-wrapper roxy-panel__message-wrapper--agent">
                    <div className="roxy-panel__message roxy-panel__message--agent roxy-panel__message--typing">
                        <span className="roxy-panel__typing" aria-label="Roxy is thinking">
                            <i /><i /><i />
                        </span>
                    </div>
                </div>
            )}
            <div ref={bottomRef} />
        </div>
    );
};

export default ChatMessages;
